
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#50585B","stroke-width":"1.1","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13 17.696H1V1h24v8.87M22.898 18.217V25l-3.13-2.609L16.636 25v-6.783"}}),_c('path',{attrs:{"d":"M18.202 15.087a1.565 1.565 0 113.13 0 1.565 1.565 0 01-3.13 0z"}}),_c('path',{attrs:{"d":"M23.642 15.087a2.08 2.08 0 00.184-2.348 2.086 2.086 0 00-2.125-1.015 2.084 2.084 0 00-1.942-1.333c-.886 0-1.638.554-1.941 1.334a2.082 2.082 0 00-2.125 1.014 2.083 2.083 0 00.184 2.348 2.083 2.083 0 00-.184 2.348 2.082 2.082 0 002.126 1.015 2.083 2.083 0 001.94 1.333c.887 0 1.64-.555 1.943-1.334a2.082 2.082 0 002.124-1.014 2.082 2.082 0 00-.184-2.348z"}}),_c('path',{attrs:{"d":"M22.913 8.818V6.21a3.13 3.13 0 01-3.13-3.13H6.216a3.13 3.13 0 01-3.13 3.13v6.26a3.13 3.13 0 013.13 3.13H13"}})])])
          )
        }
      }
    